import React, {useEffect} from "react";
import {FastField, FormikProps} from 'formik';


interface IFormikExternalPropsListenerProps {
  listenProps?: any[];
  onChange?: (form: FormikProps<any>, listenProps: any) => void;
}

const PropFormikValueSet = props => {
  useEffect(() => {
    if (props.onChange) {
      props.onChange(props.form, props.listenProps);
    }
  }, props.listenProps);
  return null;
};


const FormikExternalPropsListener = (props: IFormikExternalPropsListenerProps) => {
  return (
    <FastField
      component={PropFormikValueSet}
      {...props}
    />
  );
};

FormikExternalPropsListener.defaultProps = {
  listenProps: [],
  onChange: () => {
  },
};

export default React.memo(FormikExternalPropsListener);
